import { routes } from "/assets/routes.ts";

export default defineNuxtRouteMiddleware((to, from) => {
  const page = qsDecode(to.path.split("/")[1]);
  const toHeader = qsDecode(to.path.split("/")[2]);
  const fromHeader = qsDecode(from.path.split("/")[2]);
  const toSubheader = qsDecode(to.path.split("/")[3]);
  const fromSubheader = qsDecode(from.path.split("/")[3]);
  const headerChange = fromHeader !== toHeader;
  const subheaderChange = fromSubheader !== toSubheader;

  if (page === "admin") {
    //don't add page transitions.
    return;
  }

  if (to.path === "/") {
    to.meta.pageTransition = { name: "page-right" };
    from.meta.pageTransition = { name: "page-right" };
  } else if (from.path === "/") {
    to.meta.pageTransition = { name: "page-left" };
    from.meta.pageTransition = { name: "page-left" };
  } else if (headerChange) {
    // if the change is on the header level
    const headers = Array.from(Object.keys(routes[page]));
    if (headers.indexOf(toHeader) > headers.indexOf(fromHeader)) {
      // the header we are navigating to is to the right of the previous route's header
      to.meta.pageTransition = { name: "header-right" };
      from.meta.pageTransition = { name: "header-right" };
    } else {
      to.meta.pageTransition = { name: "header-left" };
      from.meta.pageTransition = { name: "header-left" };
    }
  } else if (subheaderChange) {
    // if the change is on the subheader level
    const subheaders = routes[page][toHeader];
    if (subheaders.indexOf(toSubheader) > subheaders.indexOf(fromSubheader)) {
      // the header we are navigating to is to the right of the previous route's header
      to.meta.pageTransition = { name: "subheader-right" };
      from.meta.pageTransition = { name: "subheader-right" };
    } else {
      to.meta.pageTransition = { name: "subheader-left" };
      from.meta.pageTransition = { name: "subheader-left" };
    }
  }
});
